import React from 'react';

export const LibrarySlideOverContext = React.createContext({
  libraryItem: {},
  setLibraryItem: () => {},
});
